var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5,
    fill: "url(#paint0_linear_4236_113105)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85136 9.20703C7.47992 9.20703 7.13597 8.92481 7.20173 8.55923C7.26192 8.22463 7.43993 7.94993 7.81445 7.73438C8.36914 7.41406 8.49805 7.27344 8.49805 6.95703V6.94922C8.49805 6.69141 8.27539 6.51172 7.9707 6.51172C7.92974 6.51172 7.89036 6.51564 7.85286 6.5232C7.45769 6.60282 7.116 7.05381 6.71289 7.05273C6.31131 7.05165 5.96501 6.71117 6.12371 6.34227C6.40393 5.69093 7.09891 5.30859 8.08008 5.30859C9.33008 5.30859 10.1348 5.9375 10.1348 6.91406V6.92188C10.1348 7.48438 9.88086 7.87109 9.2832 8.21484C9.09937 8.31989 8.94924 8.41901 8.83614 8.53511C8.55229 8.82648 8.25814 9.20703 7.85136 9.20703ZM7.92383 11.1562C7.36523 11.1562 7.04492 10.8828 7.04492 10.3945C7.04492 9.90234 7.36523 9.62891 7.92383 9.62891C8.48633 9.62891 8.80273 9.90234 8.80273 10.3945C8.80273 10.8828 8.48633 11.1562 7.92383 11.1562Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4236_113105",
    x1: 3,
    y1: 3,
    x2: 6.28652,
    y2: 14.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03E2DA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.02001396cde0bc37334ea0c779a1b3ed.svg";
export { ForwardRef as ReactComponent };